export interface SchematicsModel {
    projectId: string;
    equipmentsList: SREquipmentsDto[];
    miscellaneous?: SRMiscellaneousModel;
    eoTubing?: number;
    intakeSetDepth?: number;
    sensorDepth?: number;
    setDepth?: number;
    totalEspLength: number;
    espTailPipeDescender : number;
    mleLength: number;
    downholeEquipmentWeight: number;
    unitSystem : number;
}

export interface SREquipmentsDto {
    projectId: string;
    equipmentId?: string;
    displayOrder: number;
    createdOn?: Date;
    equipmentType: EquipmentType;
    equipments?: string;
    parentId?: string;
    length?: number;
    weight?: number;
    pn?: number;
    diameter?: string;
    setDepth?: number;
    equipmentName: string;
    id?: string;
    noStgs?: number;
    od?: number;
    dimension? : string;
    series? : string;
    configuration? : string;
    shaftType?: string
}

export interface SRMiscellaneousModel {
    projectId?: string;
    tailPipeJoints?: number;
    tailPipeDiameter?: string;
    tailPipeSetDepth? : number;
    createdOn?: Date;
    createdBy?: number;
    modifiedOn?: Date;
    modifiedBy?: number;
    note?: string;
    setDepthType?: number;
    setDepthValue?: number;
    miscList?: SRMiscEquipmentsListDto[];
    startupFrequency?: number;
    minFrequency?:number;
    maxFrequency?:number;
    tailPipeWeight?: number
    showSchematicData?:boolean;
}

export interface SRMiscEquipmentsListDto {
    equipmentName: string;
    isRequired: boolean;
    type: string;
    provider: string;
    quantity: number;
}

export enum EquipmentType {
    SRAccBelowESP = 1,
    SRSensor = 2,
    SRMotors = 3,
    SRProtectors = 4,
    SRGasSeparators = 5,
    SRGasHandlers = 6,
    SRChargePump1 = 7,
    SRChargePump2 = 8,
    SRChargePump3 = 9,
    SRPumps = 10,
    SRBOH = 11,
    SRAccAboveESP = 12,
    SRMLE = 13,
    SRCables = 14,
    SRTransformers = 15,
    SRVSDs = 16
}